import React from "react";
import {
  Create,
  SimpleForm,
  TextInput,
  required,
  email as validateEmail,
  useRedirect,
  useNotify,
} from "react-admin";
import { Box, Typography } from "@mui/material";

const AdminCreate: React.FC = () => {
  const redirect = useRedirect();
  const notify = useNotify();

  // The document id is the lowercased email, so the whole system (admin panel,
  // Firestore rules, and sync API) keys off a single normalized value.
  const transform = (data: any) => {
    const normalized = (data.email || "").trim().toLowerCase();
    return {
      id: normalized,
      email: normalized,
      displayName: data.displayName || "",
      note: data.note || "",
      addedAt: new Date().toISOString(),
    };
  };

  const onSuccess = () => {
    notify("adminsPage.createSuccess", { type: "success" });
    redirect("/admins");
  };

  const onError = () => {
    notify("adminsPage.createError", { type: "error" });
  };

  return (
    <Create
      resource="admins"
      transform={transform}
      mutationOptions={{ onSuccess, onError }}
    >
      <SimpleForm>
        <Box mb={2}>
          <Typography variant="body2" color="textSecondary">
            Add an email address to grant admin access. It must match the Google
            account the person signs in with. Access takes effect immediately for
            this panel and the database rules, and within a minute for the sync API.
          </Typography>
        </Box>
        <TextInput
          source="email"
          label="Email"
          fullWidth
          validate={[required(), validateEmail()]}
          helperText="e.g. person@company.com"
        />
        <TextInput
          source="displayName"
          label="Name"
          fullWidth
          helperText="Optional — for your reference"
        />
        <TextInput
          source="note"
          label="Note"
          fullWidth
          multiline
          rows={2}
          helperText="Optional — e.g. team or reason for access"
        />
      </SimpleForm>
    </Create>
  );
};

export default AdminCreate;
